import styles from "./Flex.module.scss";

type AlignItems =
  | "normal"
  | "center"
  | "start"
  | "end"
  | "stretch"
  | "baseline";

type AlignContent =
  | "normal"
  | "center"
  | "start"
  | "end"
  | "space-around"
  | "space-between"
  | "stretch";

type JustifyItems = "normal" | "center" | "start" | "end" | "stretch";

type JustifyContent =
  | "normal"
  | "center"
  | "start"
  | "end"
  | "space-between"
  | "space-around"
  | "space-evenly";

type FlexDirection = "row" | "column";

type FlexWrap = "wrap" | "nowrap";

interface FlexProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  gap?: string;
  flexWrap?: FlexWrap;
  flexDirection?: FlexDirection;
  alignItems?: AlignItems;
  alignContent?: AlignContent;
  justifyItems?: JustifyItems;
  justifyContent?: JustifyContent;
  block?: boolean;
}

const Flex: React.FC<FlexProps> & {
  Row: React.FC<FlexProps>;
  Col: React.FC<FlexProps>;
} = ({
  gap,
  children,
  className,
  flexWrap,
  flexDirection,
  alignItems,
  alignContent,
  justifyItems,
  justifyContent,
  block,
  ...rest
}): React.ReactElement => {
  const classes = [
    className,
    styles.flex,
    flexWrap && styles[flexWrap],
    flexDirection && styles[flexDirection],
    alignItems && styles[`a-items-${alignItems}`],
    alignContent && styles[`a-content-${alignContent}`],
    justifyItems && styles[`j-items-${justifyItems}`],
    justifyContent && styles[`j-content-${justifyContent}`],
    block && styles.block,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} style={{ gap }} {...rest}>
      {children}
    </div>
  );
};

const Row = ({ children, ...rest }) => (
  <Flex flexDirection="row" {...rest}>
    {children}
  </Flex>
);

const Col = ({ children, ...rest }) => (
  <Flex flexDirection="column" {...rest}>
    {children}
  </Flex>
);

Flex.Row = Row;
Flex.Col = Col;

export default Flex;
